import React, {useState} from 'react';
import {DataView} from "primereact/dataview";
import Icon from "../../../system/components/icon";
import {useTranslate} from "../../../system/useTranslate";
import {Button} from "primereact/button";
import {DateObject} from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import {useUpdateEffect} from "primereact/hooks";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";

function SelectCycle({value, onChange, onHide}) {
    const translate = useTranslate();
    const [cycle, setCycle] = useState(value||{range:"", year:new DateObject().setCalendar(persian).year});

    useUpdateEffect(()=>{
        onChange?.(cycle)
    },[cycle])

    useUpdateEffect(()=>{
        onHide?.();
        onChange?.(cycle);
    },[cycle.range])

    const ItemTemplate = (data)=>{
        return(

            <div className={`${data?.className}`}>
                <CardView className="align-items-center flex h-full" onClick={()=>{setCycle({...cycle, range: data?.value})}}>
                    {data.render}
                </CardView>

            </div>
        )
    }
    const cards = [
        {
            className: "p-1 w-3 flex align-items-center justify-content-center",
            value:"Q1",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="Q1"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("Q1")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )
        },
        {
            className: "p-1 w-3 flex align-items-center justify-content-center",
            value:"Q2",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="Q2"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("Q2")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )
        },
        {
            className: "p-1 w-3 flex align-items-center justify-content-center",
            value:"Q3",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="Q3"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("Q3")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )
        },
        {
            className: "p-1 w-3 flex align-items-center justify-content-center",
            value:"Q4",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="Q4"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("Q4")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )

        },
        {
            className: "p-1 w-6 flex align-items-center justify-content-center",
            value:"H1",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="H1"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("H1")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )
        },
        {
            className: "p-1 w-6 flex align-items-center justify-content-center",
            value:"H2",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="H2"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("H2")}</span>
                    {/*<span className="font-bold">{""}</span>*/}
                </div>
            )

        },
        {
            className: "p-1 w-full flex align-items-center justify-content-center",
            value:"Y",
            render:(
                <div className={`flex flex-column align-items-center justify-content-center p-1 text-2xs border-round h-full w-full border-400 ${cycle.range==="Y"&&"border-1"}`}>
                    {/*<Icon icon={goalsConnected?"mi mi:check_circle":"mi mi:help"} />*/}
                    <span className="text-center p-1">{translate("Y")}</span>
                    <span className="font-bold">{""}</span>
                </div>
            )

        }
    ]

    return (
       <div className="w-25rem p-2">
           <div className="flex align-items-center justify-content-center p-1">
               <Button onClick={()=>{setCycle({...cycle, year:cycle.year+1})}} className="p-button-sm p-button-text shadow-none outline-none" icon={<Icon icon="mi mi:chevron_right"/>}/>
               <span className="flex-1 text-center">{cycle?.year}</span>
               <Button onClick={()=>{setCycle({...cycle, year:cycle.year-1})}} className="p-button-sm p-button-text shadow-none outline-none" icon={<Icon icon="mi mi:chevron_left"/>}/>
           </div>
           <DataView emptyMessage={<DatatableEmptyMessage/>} itemTemplate={ItemTemplate} value={cards} layout="grid"/>
       </div>
    );
}



function CardView ({children, className, onClick}){
    return (
        <div onClick={onClick} className={`${className} shadow-1 h-full text-xs w-full border-round  ${onClick&&"cursor-pointer hover:surface-50"}`}>
            {children}
        </div>
    )
}

export default SelectCycle;